<template>
	<div class="content">
		<div v-if="isPdfLoading" class="pdf-loading-overlay">
			<div class="pdf-loading-spinner">
				<div class="pdf-loading-text">{{ pdfLoadingMsg || 'PDF 생성 중...' }}</div>
				<div v-if="pdfLoadingTotal > 0" class="pdf-loading-bar-wrap">
					<div class="pdf-loading-bar" :style="{ width: (pdfLoadingCurrent / pdfLoadingTotal * 100) + '%' }"></div>
				</div>
			</div>
		</div>
		<div v-if="item" class="print-wrap">
			<div class="print-left">
				<!-- <select class="form-control select sm mb-3">
					<option>물건</option>
				</select> -->
				<div class="section-tit">슬라이드 선택/제외</div>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opAll" @change="setAllCheck" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>구분</th>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[0]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>INTRO</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[1]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>물건개요</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[2]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>임대정보</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[3]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축물정보</td>
						</tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="invShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>투자분석</td></tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="devShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>리모델링/신축</td></tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[4]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축 내/외부 사진</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[5]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>지도</td>
						</tr>
					</table>
				</div>
				<div class="section-tit mt-4">사진 선택/제외</div>
				<ul class="table-list">
					<li class="table-list--item" v-for="(op, idx) in item.imgObjList" :key="'opp_' + idx">
						<div class="check">
							<label class="input-checkbox">
								<input type="checkbox" v-model="op.st" @change="updateId" :disabled="!opList[4]" />
								<span class="checkbox"></span>
							</label>
						</div>
						<div class="name">{{ op.name }}</div>
					</li>
				</ul>
				<div class="section-tit mt-4" v-if="estimate.available">블록 AI추정가</div>
				<div class="estimate-control no-print" v-if="estimate.available">
					<label class="input-checkbox">
						<input type="checkbox" v-model="showEstimate" />
						<span class="checkbox"></span>
						<span class="ms-2">블록 AI추정가 표시</span>
					</label>
					<div class="estimate-edit" v-if="showEstimate">
						<label>총액(만원)<input type="number" class="form-control form-control-sm" v-model.number="estimate.total" @change="syncEstimatePyFromTotal" /></label>
						<label>평당(만원)<input type="number" class="form-control form-control-sm" v-model.number="estimate.py" @change="syncEstimateTotalFromPy" /></label>
						<div class="estimate-avm" v-if="estimateDiffersFromAvm">
							<span>블록 계산값 {{ $formatMoney(estimateAvm.total, $MONEY_FORMAT_TYPE.LOAN) }}</span>
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="resetEstimateToAvm">블록 값으로</button>
						</div>
					</div>
				</div>
				<InvestmentSidebarEditor :state="invState" :residential="invResidential" :can-save="isManager" :save-status="defaultsStatus" @change="onInvestmentEdit" @save="saveInvestmentDefaults" @reset="resetInvestmentDefaults" />
				<SlideEditor :slides="slides" :uploading="slideUploading" @change="onSlideChange" @add-photo="addPhotoSlide" @add-blank="addBlankSlide" />
				<!-- <img :src="this.img" /> -->
				<div class="cover-variant-picker no-print">
					<span class="label">표지 스타일</span>
					<label v-for="v in coverVariants" :key="v.id">
						<input type="radio" :value="v.id" v-model="coverVariant" />
						<span>{{ v.label }}</span>
					</label>
				</div>
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="copyChartImg">출력</button>
				</div>
			</div>
			<div class="print-right" id="main_print" :style="watermarkStyle">
				<!-- 1. 인트로 (표지 3 variant) -->
				<div
					v-if="opList[0]"
					id="capture_1"
					name="capture"
					class="print-section cover"
					:class="['cover-' + coverVariant, cobrandClass]"
				>
						<!-- Variant 01 Editorial: 단일 near-white 캔버스 + 우측 inset 사진 박스 + 상단 전폭 라인 + 하단 라인 2-split -->
						<template v-if="coverVariant === '01'">
							<div class="cover-paper"></div>
							<span class="cover-caption">PROPERTY OVERVIEW</span>
							<span class="cover-top-line"></span>
							<span class="cover-vstripe"></span>
							<div class="cover-photo-box">
								<img v-if="item.img" :src="item.img" alt="" class="cover-photo" />
							</div>
							<h1 class="cover-title">{{ item.building_name }}</h1>
							<div class="cover-addr-pill">{{ coverAddr }}</div>
							<span class="cover-bottom-line-l"></span>
							<div class="cover-wordmark"></div>
							<span class="cover-bottom-line-r"></span>
							<div class="cover-disclaimer">{{ disclaimerText }}</div>
						</template>

						<!-- Variant 02 Bold Burgundy: cream 상단 + full-burgundy 본문 + cream 하단 -->
						<template v-else-if="coverVariant === '02'">
							<div class="cover-top-strip">
								<span class="cover-caption">PROPERTY OVERVIEW</span>
							</div>
							<div class="cover-main">
								<div class="cover-paper"></div>
								<span class="cover-vdecor-w1"></span>
								<span class="cover-vdecor-dark"></span>
								<span class="cover-vdecor-w2"></span>
								<div class="cover-photo-box">
									<img v-if="item.img" :src="item.img" alt="" class="cover-photo" />
								</div>
								<h1 class="cover-title">{{ item.building_name }}</h1>
								<div class="cover-addr">{{ coverAddr }}</div>
								<span class="cover-bottom-line-l"></span>
								<div class="cover-wordmark"></div>
								<span class="cover-bottom-line-r"></span>
							</div>
							<div class="cover-bottom-strip">
								<div class="cover-disclaimer">{{ disclaimerText }}</div>
							</div>
						</template>

						<!-- Variant 05 Boutique Advisory: 플랫 burgundy + 상단 darker band + 좌 카드 + 하단 cream strip -->
						<template v-else-if="coverVariant === '05'">
							<div class="cover-top-band"></div>
							<div class="cover-bg">
								<img v-if="item.img" :src="item.img" alt="" class="cover-photo" />
								<div class="cover-bg-tint"></div>
								<div class="cover-bg-scrim"></div>
							</div>
							<div class="cover-cream-band">
								<div class="cover-disclaimer">{{ disclaimerText }}</div>
							</div>
							<div class="cover-top-outer">
								<div class="cover-top-row">
									<span class="cover-caption">PROPERTY OVERVIEW</span>
									<div class="cover-wordmark cover-wordmark--top"></div>
								</div>
								<span class="cover-top-line"></span>
							</div>
							<div class="cover-card">
								<h1 class="cover-title">{{ item.building_name }}</h1>
								<div class="cover-addr">
									<svg class="pin-icon" width="10" height="14" viewBox="0 0 10 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="currentColor" d="M5 0C2.24 0 0 2.24 0 5c0 3.75 5 9 5 9s5-5.25 5-9c0-2.76-2.24-5-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg>
									<span>{{ coverAddr }}</span>
								</div>
								<div class="cover-card-footer">
									<div class="cover-wordmark"></div>
									<span class="cover-card-divider"></span>
								</div>
							</div>
						</template>

						<!-- Variant 00 Classic: 구버전 표지 (common.scss `.print-section.cover` 글로벌 스타일 사용) -->
						<template v-else>
							<div class="tit">
								<div class="middle">{{ item.building_name }}</div>
								<div class="bottom">{{ coverAddr }}</div>
							</div>
							<div class="logo"></div>
						</template>
				</div>
				<!-- 2. 물건개요 — 4 섹션 (물건명/주소, 금액, 토지, 건축물) + 우측 사진/특징 -->
				<div v-if="opList[1]" id="capture_2" name="capture" class="print-section property-overview">
					<!-- 상단 PROPERTY OVERVIEW 헤더 (전체 너비) -->
					<div class="overview-header">
						<span class="overview-caption">PROPERTY OVERVIEW</span>
						<span class="overview-line"></span>
						<span class="overview-brand"></span>
					</div>
					<!-- 본문: 좌(Summary 절반 + 3 테이블) + 우(사진은 Summary 시작점부터 + 특징) -->
					<div class="body-row">
					<div class="left">
						<!-- Summary: 좌측 절반 너비, 폰트·높이 축소 -->
						<div class="overview-title-band">
							<strong class="title-main">{{ item.building_name }}</strong>
							<span class="title-slash">/</span>
							<span class="title-addr">{{ bodyAddr }}</span>
						</div>
						<div class="metric-bar">
							<div class="metric">
								<div class="metric-label">매매금액</div>
								<div class="metric-value">{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}</div>
								<div class="metric-sub">평당 {{ $formatMoney((item.land_size_p ? Math.floor(item.sell_price / item.land_size_p) : 0), $MONEY_FORMAT_TYPE.LOAN) }}</div>
							</div>
							<div class="metric">
								<div class="metric-label">수익률</div>
								<div class="metric-value">{{ item.total_income_rate }}%</div>
								<div class="metric-sub">연간 기준</div>
							</div>
							<div class="metric">
								<div class="metric-label">연면적 / 대지면적</div>
								<div class="metric-value">{{ Math.round(Number(item.total_size_p) || 0).toLocaleString('ko-KR') }}평 / {{ Math.round(Number(item.land_size_p) || 0).toLocaleString('ko-KR') }}평</div>
								<div class="metric-sub">건폐 {{ $formatRatio(item.bl_ratio) }} / 용적 {{ $formatRatio(item.fa_ratio) }}</div>
							</div>
							<div class="metric">
								<div class="metric-label">주변역</div>
								<div class="metric-value">{{ item.substation || '-' }}</div>
								<div class="metric-sub"><template v-if="item.substation_distance">{{ item.substation_distance }}m</template></div>
							</div>
						</div>
						<div class="bottom">
							<!-- 섹션 B: 금액정보 -->
							<div class="section-tit section-tit--print-header">금액정보</div>
							<div class="table-wrap">
								<table class="table text-left type-input compact">
									<colgroup>
										<col width="32%" />
										<col width="68%" />
									</colgroup>
									<tr>
										<th class="txt-c--red">매매금액</th>
										<td class="txt-c--red">
											<span class="float-start p-0">{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}</span>
											<span class="float-end p-0 txt-c--red">[평당:{{ $formatMoney((item.land_size_p ? Math.floor(item.sell_price / item.land_size_p) : 0), $MONEY_FORMAT_TYPE.LOAN) }}]<span v-if="estimateBadge && estimateBadge.kind === 'under'" class="sell-compare"> · {{ estimateBadge.comparePyText }}</span></span>
										</td>
									</tr>
									<tr v-if="showEstimate && estimate.available">
										<th>블록 AI추정가</th>
										<td>
											<span class="float-start p-0">{{ $formatMoney(estimate.total, $MONEY_FORMAT_TYPE.LOAN) }}<span v-if="estimateBadge && estimateBadge.kind !== 'premium'" class="estimate-badge" :class="'estimate-badge--' + estimateBadge.kind">{{ estimateBadge.text }}</span></span>
											<span class="float-end p-0">[평당:{{ $formatMoney(estimate.py, $MONEY_FORMAT_TYPE.LOAN) }}]</span>
										</td>
									</tr>
									<tr v-if="estimateBadge && estimateBadge.kind === 'premium'" class="estimate-note-row">
										<td colspan="2">
											<span class="note-badge">참고</span>
											<span class="estimate-note-text">{{ estimateNote }}</span>
										</td>
									</tr>
									<tr>
										<th>토지가격</th>
										<td>
											<span class="float-start p-0">{{ $formatMoney(item.land_price, $MONEY_FORMAT_TYPE.LOAN) }}</span>
											<span class="float-end p-0 txt-c--red">
												[평당:{{ $formatMoney(item.land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
											</span>
										</td>
									</tr>
									<tr>
										<th>건물가격</th>
										<td>
											<span class="float-start p-0">{{ $formatMoney(item.building_price, $MONEY_FORMAT_TYPE.LOAN) }}</span>
											<span class="float-end p-0">
												[평당:{{ $formatMoney(item.building_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
											</span>
										</td>
									</tr>
									<tr>
										<th>연면적 평당가격</th>
										<td>{{ $formatMoney(item.total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
									</tr>
									<tr>
										<th>보증금</th>
										<td>{{ $formatMoney(item.ex_sum_rent_deposit, $MONEY_FORMAT_TYPE.LOAN) }}</td>
									</tr>
									<tr>
										<th>월임대료</th>
										<td>{{ $formatMoney(item.ex_sum_rent_money, $MONEY_FORMAT_TYPE.LOAN) }}</td>
									</tr>
									<tr>
										<th>관리비</th>
										<td>{{ item.ex_sum_mgr_fee ? $formatMoney(item.ex_sum_mgr_fee, $MONEY_FORMAT_TYPE.LOAN) : '-' }}</td>
									</tr>
									<tr>
										<th>총수익</th>
										<td>{{ (item.total_income !== '' && item.total_income !== null && Number.isFinite(Number(item.total_income))) ? $formatMoney(item.total_income, $MONEY_FORMAT_TYPE.LOAN) : '-' }}</td>
									</tr>
									<tr>
										<th class="txt-c--red">수익률</th>
										<td class="txt-c--red">{{ item.total_income_rate }}%</td>
									</tr>
								</table>
							</div>

							<!-- 섹션 C: 토지정보 -->
							<div class="section-tit section-tit--print-header">토지정보</div>
							<div class="table-wrap">
								<table class="table text-left type-input compact">
									<colgroup>
										<col width="32%" />
										<col width="68%" />
									</colgroup>
									<tr>
										<th class="txt-c--red">대지면적</th>
										<td class="txt-c--red">
											<span class="float-start p-0">{{ $formatArea(item.land_size_m2) }}㎡({{ $formatArea(item.land_size_p) }}평)</span>
											<span class="float-end p-0">
												[평당:{{ $formatMoney(item.land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
											</span>
										</td>
									</tr>
									<tr>
										<th>용도지역</th>
										<td>{{ item.cfg_val1 }}</td>
									</tr>
									<tr>
										<th>주변역/거리</th>
										<td>{{ item.substation }} <template v-if="item.substation_distance">[{{ item.substation_distance }}m]</template></td>
									</tr>
									<tr>
										<th>공시지가/합계</th>
										<td>
											<span class="float-start p-0">
												{{ $formatMoney(item.public_land_price, $MONEY_FORMAT_TYPE.LOAN) }}
											</span>
											<span class="float-end p-0">
												[평당:{{ $formatMoney(item.public_land_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
											</span>
										</td>
									</tr>
									<tr>
										<th>도로사항</th>
										<td>
											<template v-if="item.roadwide_1">{{ item.roadwide_1 }}m</template>
											<template v-if="item.roadwide_2">,{{ item.roadwide_2 }}m</template>
											<template v-if="item.roadwide_3">,{{ item.roadwide_3 }}m</template>
											<template v-if="item.roadwide_4">,{{ item.roadwide_4 }}m</template>
											<template v-if="item.chk_road_coner == 'Y'">,코너</template>
											<template v-if="item.chk_road_dual == 'Y'">,양면</template>
											<template v-if="item.road_name"> [{{ item.road_name }}]</template>
										</td>
									</tr>
								</table>
							</div>

							<!-- 섹션 D: 건축물정보 -->
							<div class="section-tit section-tit--print-header">건축물정보</div>
							<div class="table-wrap">
								<table class="table text-left type-input compact">
									<colgroup>
										<col width="32%" />
										<col width="68%" />
									</colgroup>
									<tr>
										<th class="txt-c--red">연면적</th>
										<td class="txt-c--red">
											<span class="float-start p-0">{{ $formatArea(item.total_size_m2) }}㎡({{ $formatArea(item.total_size_p) }}평)</span>
											<span class="float-end p-0">
												[평당:{{ $formatMoney(item.total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
											</span>
										</td>
									</tr>
									<tr>
										<th>건축면적</th>
										<td>
											<span class="float-start p-0">{{ $formatArea(item.build_size_m2) }}㎡({{ $formatArea(item.build_size_p) }}평)</span>
											<span class="float-end p-0">
												[평당:{{
													$formatMoney((item.build_size_p ? Math.floor(item.sell_price / item.build_size_p) : 0), $MONEY_FORMAT_TYPE.LOAN)
											}}]
											</span>
										</td>
									</tr>
									<tr>
										<th>규모</th>
										<td>{{ $getFloorString(item.floor_cnt_B, item.floor_cnt_F) }}</td>
									</tr>
									<tr>
										<th>준공년도 / 리모델링</th>
										<td>{{ $dateKorFormat(item.build_date) + ' / ' + $dateKorFormat(item.remodel_date) }}</td>
									</tr>
									<tr>
										<th>주용도</th>
										<td>{{ item.main_purpose }}</td>
									</tr>
									<tr>
										<th>건폐율 / 용적률</th>
										<td>{{ $formatRatio(item.bl_ratio) }}/{{ $formatRatio(item.fa_ratio) }}</td>
									</tr>
									<tr>
										<th>주차방식/대수</th>
										<td>
											<template v-if="item.park_type_name">{{ item.park_type_name }} /</template>
											법정 {{ item.park_cnt_law }}대 / 실제 {{ item.park_cnt_real }}대
										</td>
									</tr>
									<tr>
										<th>냉/난방식</th>
										<td>{{ item.heat_type_name }}</td>
									</tr>
									<tr>
										<th>승강기</th>
										<td>{{ item.ev_cnt }}대</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
					<div class="right ms-2">
						<div class="img-wrap">
							<img :src="item.img" alt="" class="property-photo-fixed" />
						</div>
						<div class="section-tit section-tit--print-header features-header">특징</div>
						<ol class="features-list box-line features-body">
							<li v-for="(line, idx) in getFeatureLines(item.memo)" :key="idx">{{ line }}</li>
						</ol>
					</div>
					</div>
					<div class="page-footer-disclaimer">
						<p>{{ pageFooterLine1 }}</p>
						<p>{{ pageFooterLine2 }}</p>
					</div>
				</div>
				<!-- 3. 임대정보 -->
				<div v-if="opList[2]" id="capture_3" name="capture" class="print-section">
					<div class="print-tit">STACKING PLAN</div>
					<div class="table-wrap">
						<table class="table sm">
							<thead>
								<tr>
									<th>층</th>
									<th>임대면적(㎡)</th>
									<th>임대면적(평)</th>
									<th>용도</th>
									<th>보증금</th>
									<th>월세</th>
									<th>관리비</th>
									<th>평당임대료</th>
									<th>만기</th>
									<th>비고</th>
								</tr>
							</thead>
							<tbody>
								<tr :key="'rent_' + rent.building_rent_uid" v-for="rent in rentList" :class="{ 'rent-excluded': rent.except_flag === 'Y' }">
									<th>{{ rent.rent_floor }}</th>
									<td>{{ $formatArea(rent.rent_size_m2) }}</td>
									<td>{{ $formatArea(rent.rent_size_p) }}</td>
									<td>{{ rent.rent_usage }}</td>
									<td>{{ $formatNumber(rent.rent_deposit) }}</td>
									<td>{{ $formatNumber(rent.rent_money) }}</td>
									<td>{{ rent.mgr_fee ? $formatNumber(rent.mgr_fee) : 0 }}</td>
									<td>{{ $formatNumber(rent.rent_ni) }}</td>
									<td>{{ rent.end_date }}</td>
									<td>{{ rent.memo }}</td>
								</tr>
								<tr>
									<th class="bg-blue">합계</th>
									<td class="bg-blue">{{ $formatNumber(totalData.m2) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.py) }}</td>
									<td class="bg-blue"></td>
									<td class="bg-blue">{{ $formatNumber(totalData.deposit) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.money) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.mgr) }}</td>
									<td class="bg-blue">{{ $formatNumber(totalData.rent_ni) }}</td>
									<td class="bg-blue"></td>
									<td class="bg-blue"></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="table-text">※ 임대차계약서 상 임대면적의 총합과 건축물대장 상 연면적이 다소 차이가 있음</div>
					<div class="page-footer-disclaimer">
						<p>{{ pageFooterLine1 }}</p>
						<p>{{ pageFooterLine2 }}</p>
					</div>
				</div>
				<!-- 4. 건축물정보 -->
				<div v-if="opList[3]" id="capture_4" name="capture" class="print-section">
					<div class="print-tit">BUILDING REGISTER</div>
					<div class="table-wrap">
						<table class="table sm">
							<thead>
								<tr>
									<th>층</th>
									<th>면적(㎡)</th>
									<th>평수</th>
									<th>층별용도</th>
								</tr>
							</thead>
							<tbody>
								<tr :key="'floor_' + floor.building_floor_uid" v-for="floor in floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
									<td>{{ floor.flrNoNm }}</td>
									<td>{{ $formatArea(floor.area_m2) }}</td>
									<td>{{ $formatArea(floor.area_py) }}</td>
									<td>{{ floor.name }}</td>
								</tr>
								<tr>
									<td class="bg-blue">합계</td>
									<td class="bg-blue">{{ totalFloorData.m2 }}</td>
									<td class="bg-blue">{{ totalFloorData.py }}</td>
									<td class="bg-blue"></td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="page-footer-disclaimer">
						<p>{{ pageFooterLine1 }}</p>
						<p>{{ pageFooterLine2 }}</p>
					</div>
				</div>
				<InvestmentAnalysisPage v-if="invShow && invAcq" :acq="invAcq" :tax-rate="invState.taxRate" :broker-rate="invState.brokerRate" :ltv="invState.ltv" :loan-rate="invState.loanRate" :noi="invState.noi" :residential="invResidential" />
				<DevelopmentPlanPage v-if="devShow && invDev && invFunding" :dev="invDev" :funding="invFunding" />

				<!-- 5. 건물 내/외부 (사진 여러개)-->
				<template v-if="opList[4]">
					<div
						v-for="(pic, idx) in item.imgObj"
						:id="'picture_' + idx"
						:key="'picture_' + idx"
						class="print-section flex"
						name="capture"
					>
						<div class="print-tit">PHOTO</div>
						<template v-for="(i, ii) in pic" :key="idx + '_' + ii + '_' + 'pic'">
							<div v-if="(ii = 0)" class="left">
								<div class="section-tit">{{ i.name }}</div>
								<div class="img-wrap">
									<img :src="i.img" alt="" style="width: 540px; height: 650px" />
								</div>
							</div>
							<div v-else class="right">
								<div class="section-tit">{{ i.name }}</div>
								<div class="img-wrap">
									<img :src="i.img" alt="" style="width: 540px; height: 650px" />
								</div>
							</div>
						</template>
						<div class="page-footer-disclaimer">
							<p>{{ pageFooterLine1 }}</p>
							<p>{{ pageFooterLine2 }}</p>
						</div>
					</div>
				</template>
				<!-- 6. 지도 -->
				<div v-show="opList[5]" id="capture_5" name="capture" class="print-section flex">
					<div class="left">
						<div class="print-tit">MAP</div>
						<div id="map_1"></div>
					</div>
					<div class="right">
						<div class="print-tit">MAP</div>
						<div id="map_2"></div>
					</div>
					<div class="page-footer-disclaimer">
						<p>{{ pageFooterLine1 }}</p>
						<p>{{ pageFooterLine2 }}</p>
					</div>
				</div>

				<!-- #7 부록 슬라이드(맨 뒤, end 표지 직전) -->
				<SlidePage v-for="s in slides" :key="'slide_' + s.id" :id="'slide_' + s.id" name="capture" :slide="s" />
				<!-- 7. end -->
				<div name="capture" id="capture_99" class="print-section cover end">
					<ul class="info" :class="cobrandClass">
						<li class="info-item name">
							<span class="text">
								<strong>{{ userInfo.mem_name }}</strong> {{ userInfo.mem_rank_name }}
							</span>
						</li>
						<li class="info-item">
							<label class="label">M.</label>
							<span class="text">{{ userInfo.mem_mobile }}</span>
						</li>
						<li class="info-item">
							<label class="label">T.</label>
							<span class="text">02-6956-2791</span>
						</li>
						<li class="info-item">
							<label class="label">E.</label>
							<span class="text">{{ userInfo.mem_email }}</span>
						</li>
						<li class="info-item">
							<label class="label">F.</label>
							<span class="text">{{ userInfo.mem_fax || '070-4693-5728' }}</span>
						</li>
						<li class="info-item">
							<span class="text">서울특별시 강남구 학동로25길 11, 5층 (논현동, 씨플레이스)</span>
						</li>
					</ul>
					<!-- 신한/대신 제휴 게스트 PDF: 위온어스 중개법인 Contact Point 배너(첨부 디자인) 항상 표기 -->
					<div class="broker-corp" v-if="cobrandClass">
						<div class="bc-title">Contact Point</div>
						<div class="bc-corp"><strong>위온어스부동산중개법인</strong><span class="bc-addr"> (서울특별시 강남구 학동로25길 11, 5층(논현동, 씨플레이스))</span></div>
						<div class="bc-col bc-col1">
							<div class="bc-name">서치원 대표</div>
							<div class="bc-tel">+82 010-5566-4948</div>
						</div>
					</div>
					<div class="bottom-text">
						본 Teaser는 본 건 투자를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다. Teaser의 세부적인 내용은 추후
						진행사항에 따라 수정되거나 변경될 수 있고, WEONUS 는 내용에 대해 어떠한 책임도 부담하지 않습니다.<br />
						또한 Teaser에서 제공한 정보는 어떠한 제약의 근거로 사용될 수 없습니다. Teaser의 어떠한 부분도 매도자 및
						WEONUS의 사전 동의 없이 외부에 복사, 인용, 재배포 및 유통될 수 없습니다.
					</div>
				</div>

				<!--

				7. end
				<div name="capture" id="capture_6" class="print-section cover">
					<ul class="info">
						<li class="info-item">
							<label class="label">담당자</label>
							<span class="text">박정훈 차장</span>
						</li>
						<li class="info-item">
							<label class="label">Mobile</label>
							<span class="text">010-3441-5886</span>
						</li>
						<li class="info-item">
							<label class="label">TEL</label>
							<span class="text"></span>
						</li>
						<li class="info-item">
							<label class="label">FAX</label>
							<span class="text">02-111-2222</span>
						</li>
						<li class="info-item">
							<label class="label">E-mail</label>
							<span class="text"></span>
						</li>
						<li class="info-item">
							<span class="text">서울특별시 강남구 학동로25길 11, 5층 (논현동, 씨플레이스)</span>
						</li>
					</ul>
					<div class="bottom-text">
						본 Teaser는 본건 투자를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다.<br />
						본 Teaser의 내용은 추후 진행사항에 따라 수정되거나 변경될 수 있고,<br />
						내용의 대하여 어떠한 책임도 부담하지 아니합니다. <br />
						또한 본 Teaser에서 제공된 정보는 어떠한 제약의 근거로 사용될 수 없습니다.<br />
						본 Teaser의 어떤 부분도 매도자 및 WEONUS의 사전 서면동의 없이 <br />
						외부에 복사, 인용, 배포, 유통될 수 없습니다.
					</div>
				</div>
				8. 임대 개요
				<div name="capture" id="capture_7" class="print-section flex1-2">
					<div class="left">
						<div class="img-wrap">
							<img src="" alt="" />
						</div>
					</div>
					<div class="right">
						<div class="flex">
							<div>
								<div class="section-tit">임대정보</div>
								<div class="table-wrap">
									<table class="table type-input">
										<colgroup>
											<col width="20%" />
											<col width="30%" />
											<col width="20%" />
											<col width="30%" />
										</colgroup>
										<tr>
											<th>주소</th>
											<td colspan="3">서울</td>
										</tr>
										<tr>
											<th class="txt-c--red">보증금</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th class="txt-c--red">월세</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th>관리비</th>
											<td colspan="3">1만원</td>
										</tr>
										<tr>
											<th class="txt-c--red">월고정비</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th class="txt-c--red">전용면적</th>
											<td class="txt-c--red">0평</td>
											<th>전용률</th>
											<td>80%</td>
										</tr>
										<tr>
											<th>임대면적</th>
											<td colspan="3">0평</td>
										</tr>
										<tr>
											<th class="txt-c--red">평당임대료</th>
											<td colspan="3" class="txt-c--red">1만원</td>
										</tr>
										<tr>
											<th>층정보</th>
											<td>1층</td>
											<th>입주현황</th>
											<td>공실</td>
										</tr>
										<tr>
											<th>무료 주차대수</th>
											<td>100평당 1대</td>
											<th>유료 주차대수</th>
											<td>가능</td>
										</tr>
										<tr>
											<th>화장실 유형</th>
											<td colspan="3">각 층 남녀 분리</td>
										</tr>
										<tr>
											<th>인테리어</th>
											<td colspan="3">철거완료</td>
										</tr>
										<tr>
											<th>렌트프리</th>
											<td colspan="3">2개월</td>
										</tr>
									</table>
								</div>
							</div>
							<div>
								<div class="section-tit">토지정보</div>
								<div class="table-wrap">
									<table class="table type-input">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tr>
											<th class="txt-c--red">주변역</th>
											<td class="txt-c--red">00역</td>
										</tr>
										<tr>
											<th class="txt-c--red">거리</th>
											<td class="txt-c--red">22m</td>
										</tr>
										<tr>
											<th>대지면적</th>
											<td>00㎡</td>
										</tr>
										<tr>
											<th>도로사항</th>
											<td>00㎡ 코너</td>
										</tr>
									</table>
								</div>
								<div class="section-tit mt-4">건축물정보</div>
								<div class="table-wrap">
									<table class="table type-input">
										<colgroup>
											<col width="50%" />
											<col width="50%" />
										</colgroup>
										<tr>
											<th>준공연도/리모델링</th>
											<td>2022-01-01 / 2022-01-01</td>
										</tr>
										<tr>
											<th class="txt-c--red">승강기</th>
											<td class="txt-c--red">1대</td>
										</tr>
										<tr>
											<th>냉/난방식</th>
											<td>개별 냉/난방</td>
										</tr>
										<tr>
											<th>규모</th>
											<td>지하1층 / 지상10층</td>
										</tr>
										<tr>
											<th>주차방식/대수</th>
											<td>자주식 / 10대</td>
										</tr>
										<tr>
											<th>연면적</th>
											<td>11.11[10평]</td>
										</tr>
										<tr>
											<th>건축면적</th>
											<td>11.11[10평]</td>
										</tr>
									</table>
								</div>
							</div>
						</div>
						<div class="section-tit mt-4">특징</div>
						<ul class="dot-list">
							<li class="dot-list--item">특징1</li>
							<li class="dot-list--item">특징2</li>
							<li class="dot-list--item">특징3</li>
						</ul>
					</div>
				</div>
				9. 비교
				<div name="capture" id="capture_8" class="print-section flex2-1">
					<div class="left">
						<div class="print-tit">COMPARABLE(비교)</div>
						<div class="table-wrap">
							<table class="table type-input">
								<colgroup>
									<col width="25%" />
									<col width="25%" />
									<col width="25%" />
									<col width="25%" />
								</colgroup>
								<tr>
									<th>빌딩명</th>
									<th>ㅇㅇ빌딩</th>
									<th>ㅁㅁ빌딩</th>
									<th>ㅅㅅ빌딩</th>
								</tr>
								<tr>
									<th>사진</th>
									<td>사진</td>
									<td>사진</td>
									<td>사진</td>
								</tr>
								<tr>
									<th>주소</th>
									<td>00시</td>
									<td>00시</td>
									<td>00시</td>
								</tr>
								<tr>
									<th class="txt-c--red">보증금</th>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
								</tr>
								<tr>
									<th class="txt-c--red">월세</th>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red">1만원</td>
								</tr>
								<tr>
									<th>관리비</th>
									<td>1만원</td>
									<td>1만원</td>
									<td>1만원</td>
								</tr>
								<tr>
									<th class="txt-c--red">월 고정비</th>
									<td class="txt-c--red">1만원</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th class="txt-c--red">전용면적</th>
									<td class="txt-c--red">10㎡(10평)</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th>전용률</th>
									<td>10%</td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<th>임대면적</th>
									<td>10㎡(10평)</td>
									<td></td>
									<td></td>
								</tr>
								<tr>
									<th>층정보</th>
									<td>1층 전체</td>
									<td>1층 전체</td>
									<td>1층 전체</td>
								</tr>
								<tr>
									<th class="txt-c--red">평당임대료</th>
									<td class="txt-c--red">15만원</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th>입주현황</th>
									<td>즉시입주</td>
									<td>즉시입주</td>
									<td>협의</td>
								</tr>
								<tr>
									<th>주차(유료/무료)</th>
									<td>유료1대/무료2대</td>
									<td>유료1대/무료2대</td>
									<td>유료1대/무료2대</td>
								</tr>
								<tr>
									<th>화장실 유형</th>
									<td>개별 냉난방</td>
									<td>중앙 냉난방</td>
									<td>개별 냉난방</td>
								</tr>
								<tr>
									<th>인테리어</th>
									<td>철거완료</td>
									<td>철거완료</td>
									<td>철거완료</td>
								</tr>
								<tr>
									<th>렌트프리</th>
									<td>렌트프리3개월</td>
									<td>렌트프리3개월</td>
									<td>-</td>
								</tr>
								<tr>
									<th class="txt-c--red">주변역/거리</th>
									<td class="txt-c--red">역삼역(2호선) 300m</td>
									<td class="txt-c--red">역삼역(2호선) 300m</td>
									<td class="txt-c--red">역삼역(2호선) 300m</td>
								</tr>
								<tr>
									<th class="txt-c--red">승강기</th>
									<td class="txt-c--red">1대</td>
									<td class="txt-c--red"></td>
									<td class="txt-c--red"></td>
								</tr>
								<tr>
									<th>준공년도/리모델링</th>
									<td>2022.01.01</td>
									<td>2022.01.01</td>
									<td>2022.01.01</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="right">
						<div class="section-tit">서울 강남구</div>
						<div class="map-wrap"></div>
						<div class="table-wrap">
							<div class="txt-right txt-size--sm mb-1">단위:원</div>
							<table class="table type-input">
								<tr>
									<th>NO.</th>
									<th>빌딩이름</th>
									<th>전용면적</th>
									<th>보증금</th>
									<th>월세</th>
									<th>관리비</th>
									<th>월고정비</th>
								</tr>
								<tr>
									<td>01</td>
									<td>유진빌딩(지하2~지상6층)</td>
									<td>20평</td>
									<td>60000</td>
									<td>60000</td>
									<td>포함</td>
									<td>60000</td>
								</tr>
							</table>
						</div>
					</div>
				</div>

				-->
			</div>
		</div>
	</div>
</template>

<script>
import { normalizeAddr, formatBodyAddr } from '@/utils/format';
import InvestmentAnalysisPage from '@/components/print/InvestmentAnalysisPage.vue';
import DevelopmentPlanPage from '@/components/print/DevelopmentPlanPage.vue';
import InvestmentSidebarEditor from '@/components/print/InvestmentSidebarEditor.vue';
import SlidePage from '@/components/print/SlidePage.vue';
import SlideEditor from '@/components/print/SlideEditor.vue';
import investmentProposal from '@/mixins/investmentProposal';
import { startPrintPage, markStage, markReady, markFailed } from '@/utils/printStatus.mjs';

// 추정가(AVM, bloc valuation)는 선택적·graceful 요소다. PR#78(2026-06-08)이 추정가 출처를
// (구) 단일필지·토지만 보던 block-estimate(<1s) → 다필지+건물 valuation(부하 시 간헐 15s
// 타임아웃)으로 바꾸면서, 이 비동기 로드가 init 의 critical path(지도 렌더·__VUE_READY__)에
// await 로 묶여 지도가 최대 15s 늦게 뜨고(=서버 PDF 가 빈 지도를 캡처) 30s 캡처 예산을 잠식했다.
// ready/지도 렌더가 추정가를 기다리는 상한(ms) — 이 시간 내 도착하면 캡처 포함, 늦으면 진행한다
// (늦게 도착해도 Vue 반응성으로 화면 표시 + getEstimate 가 URL override 재적용). 건강 시 ≈1.8s.
const EST_READY_GATE_MS = 4000;

export default {
	name: 'PrintPage',
	printBuildingType: 'sell',
	mixins: [investmentProposal],
	components: {
		InvestmentAnalysisPage,
		DevelopmentPlanPage,
		InvestmentSidebarEditor,
		SlidePage,
		SlideEditor,
	},
	data() {
		return {
			bid: null,
			map_1: null,
			marker_1: null,

			map_2: null,
			marker_2: null,
			mapType: null,

			indexList: [],
			capIdList: [],
			isPdfLoading: false,
			// F-5.1: progress indicator state for $exportPrint
			pdfLoadingMsg: '',
			pdfLoadingCurrent: 0,
			pdfLoadingTotal: 0,

			opAll: true,
			opList: [true, true, true, true, true, true],

			// 추정가(AVM). estimate.total/py 는 표시값이자 편집 대상(임시). showEstimate 로 본문 토글.
			// 새로고침 시 getEstimate 가 AVM 원값으로 리셋(DB 저장 없음).
			// 기본값: 비활성화. 추정가 로드 후 매매가보다 높을 때만 applyEstimateUrlOverride 가 활성화(estimateAboveSell).
			showEstimate: false,
			estimate: { available: false, total: 0, py: 0, areaPy: 0 },
			// 이번에 받은 블록 값 {total, py}(만원). 저장값·편집값과 달라졌는지 판정하고(되돌리기 버튼),
			// 손대지 않은 추정가를 출력 기본값에 굳혀 저장하지 않는 데 쓴다(investment.mjs estimateSettings).
			estimateAvm: null,

			// 표지 하단 disclaimer — V01/V02/V05 공통
			disclaimerText: '본 Teaser는 본 건 투자 검토를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다. 본 자료의 세부 내용은 향후 진행 상황에 따라 수정 또는 변경될 수 있으며, WEONUS는 이에 대해 어떠한 법적 책임도 부담하지 않습니다. 또한 본 자료에 포함된 정보는 투자 판단 또는 계약 체결의 근거로 사용될 수 없습니다.',

			// 2페이지 이후 모든 페이지 하단에 작게 표기되는 법적 고지 (capture_2~capture_5).
			pageFooterLine1: '* 본 자료에는 공개가 제한되거나 매도인의 비밀정보가 포함될 수 있습니다. 수신인이 불필요하게 수령한 경우 즉시 파기하여야 하며, WEONUS 및 매도인의 사전 서면 동의 없이 본 자료의 전부 또는 일부를 복제, 배포, 전송, 인용, 변경 또는 제3자에게 제공할 수 없습니다. 위반 시 관련 법령에 따른 민·형사상 책임이 발생할 수 있습니다.',
			pageFooterLine2: '* 본 자료는 매도인의 진술 및 제공 자료를 기초로 작성되어 실제와 차이가 있을 수 있습니다.',

			item: null,
			rentList: [],
			floorList: [],
			totalData: {
				m2: 0,
				py: 0,
				deposit: 0,
				money: 0,
				mgr: 0,
			},

			totalFloorData: {
				m2: 0,
				py: 0,
			},

			rentRate: {
				labels: ['임대율'],
				datasets: [
					{
						label: '임대율',
						data: [0],
						backgroundColor: '#f87979',
					},
				],
			},
			rentRateSt: false,
			rentRateList: {
				labels: ['임대'],
				datasets: [],
			},
			rentRateListSt: false,

			coverAddr: '',
			bodyAddr: '',

			userInfo: {},

			// 표지(cover) 4 variant 선택. 기본값 '02' (Bold Burgundy, 현 디자인 가장 근접).
			// URL ?cover=00|01|02|05 로 동기화됨. '00'은 구버전(common.scss 의 .print-section.cover 글로벌 스타일).
			coverVariants: [
				{ id: '00', label: '00 Classic' },
				{ id: '01', label: '01 Editorial' },
				{ id: '02', label: '02 Bold Burgundy' },
				{ id: '05', label: '05 Boutique Advisory' },
			],
			coverVariant: ['00', '01', '02', '05'].includes(this.$route.query.cover)
				? this.$route.query.cover
				: '02',
		};
	},
	computed: {
		// 화면 추정가가 이번에 받은 블록 값과 다른가(저장된 값이거나 손으로 고친 값).
		estimateDiffersFromAvm() {
			const a = this.estimateAvm;
			if (!a || !this.estimate || !this.estimate.available) return false;
			return Math.round(Number(this.estimate.total) || 0) !== a.total
				|| Math.round(Number(this.estimate.py) || 0) !== a.py;
		},
		coverBgStyle() {
			const src = this.item && this.item.img;
			return src ? { backgroundImage: `url(${src})` } : {};
		},
		// 페이지 워터마크 'weonus' 아래줄에 출력자(로그인 사용자) 이름 표기.
		// CSS 변수 --print-watermark-name 으로 .print-section::before 가 읽는다.
		watermarkStyle() {
			const name = (this.userInfo && this.userInfo.mem_name) || '';
			return name ? { '--print-watermark-name': `'${name.replace(/'/g, '')}'` } : {};
		},
		// 제휴 게스트(은행직원) 세션에서만 — 마지막 페이지 위온어스 × 기관 공동로고.
		cobrandClass() {
			if (!this.$store.getters.getGuest) return null;
			const inst = this.$store.getters.getInstitution;
			return inst === 'shinhan' || inst === 'daishin' ? inst : null;
		},
	},
	watch: {
		coverVariant(newVal) {
			// URL query 동기화 (새로고침/공유 대비).
			const currentQuery = { ...this.$route.query };
			if (currentQuery.cover === newVal) return;
			this.$router.replace({ query: { ...currentQuery, cover: newVal } }).catch(() => {});
		},
	},
	created() {
		this.bid = this.$route.query.bid;

		// 지도 전용 출력 페이지(Panorama 미사용): base SDK(naver.maps.Map) 준비만 기다린다.
		// 'core' 로 호출해 panorama 서브모듈 지연/실패가 지도·PDF 렌더를 막지 않게 한다.
		this.mapScriptReady = this.$loadNaverMaps('core');

		startPrintPage();
		try {
			this.init();
		} catch (e) {
			// init 이 동기 예외로 끊기면 서버가 30초를 기다리게 두지 않는다.
			console.warn('init aborted:', e);
			markFailed('init aborted: ' + ((e && e.message) || e));
		}
	},
	methods: {
		init() {
			this.getItem();
			this.getRent();
			this.getFloor();
			this.getUser();
			this.estimatePromise = this.getEstimate();
		},
		estimateAreaPy() {
			// 추정가 평면적(평): 로드 시 캡처한 AVM 일관면적(총액/평당), 평당0 이면 대지면적평 폴백
			if (this.estimate.areaPy > 0) return this.estimate.areaPy;
			const lp = Number(this.item && this.item.land_size_p);
			return Number.isFinite(lp) && lp > 0 ? lp : 0;
		},
		// 총액 수정 → 평당 자동연동(면적 기준)
		syncEstimatePyFromTotal() {
			const area = this.estimateAreaPy();
			if (area > 0) this.estimate.py = Math.round((Number(this.estimate.total) || 0) / area);
		},
		// 평당 수정 → 총액 자동연동(면적 기준)
		syncEstimateTotalFromPy() {
			const area = this.estimateAreaPy();
			if (area > 0) this.estimate.total = Math.round((Number(this.estimate.py) || 0) * area);
		},
		// 저장값·편집값을 버리고 이번에 받은 블록 값으로 되돌린다. 이 상태로 기본값을 저장하면
		// 추정가 키가 빠져, 이후 필지·모델이 바뀌어도 출력물이 블록 값을 따라간다.
		resetEstimateToAvm() {
			const a = this.estimateAvm;
			if (!a) return;
			this.estimate = { available: true, total: a.total, py: a.py, areaPy: a.py > 0 ? a.total / a.py : 0 };
			// 이전 출력이 주소에 남긴 추정가(syncEstimateToUrl)도 지운다. 남겨 두면 새로고침 때
			// applyEstimateUrlOverride 가 버린 값을 되살리고, 그 상태로 저장하면 다시 굳는다.
			const u = new URL(window.location.href);
			u.searchParams.delete('est_total');
			u.searchParams.delete('est_py');
			window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
		},
		// 편집한 추정가/표시여부를 URL 에 실어 서버 PDF(Puppeteer 가 window.location.href 재로드) 에 반영
		syncEstimateToUrl() {
			const u = new URL(window.location.href);
			if (this.estimate && this.estimate.available) {
				u.searchParams.set('est_total', String(Math.round(Number(this.estimate.total) || 0)));
				u.searchParams.set('est_py', String(Math.round(Number(this.estimate.py) || 0)));
				u.searchParams.set('est_show', this.showEstimate ? '1' : '0');
			} else {
				u.searchParams.delete('est_total');
				u.searchParams.delete('est_py');
				u.searchParams.delete('est_show');
			}
			window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
		},
		// 서버 재로드 시 URL 의 편집 추정가/표시여부를 AVM 원본 위에 덮어쓴다.
		applyEstimateUrlOverride() {
			const q = { ...(this.item && this.item.printDefaults ? this.item.printDefaults : {}), ...this.$route.query };
			if (q.est_total != null && q.est_py != null) {
				const t = Math.round(Number(q.est_total));
				const pp = Math.round(Number(q.est_py));
				if (Number.isFinite(t) && Number.isFinite(pp) && t >= 0 && pp >= 0 && (t > 0 || pp > 0)) {
					this.estimate = { available: true, total: t, py: pp, areaPy: pp > 0 ? t / pp : 0 };
				}
			}
			if (q.est_show != null) {
				this.showEstimate = String(q.est_show) !== '0';
			} else {
				// 명시적 지정(URL/DB)이 없으면: 블록 AI 추정가가 매매가보다 높을 때만 기본 활성화, 아니면 비활성화.
				this.showEstimate = this.estimateAboveSell();
			}
		},
		// 블록 AI 추정가가 매매가보다 높은가? (기본 표시 여부의 기준) 추정가/매물 미로드 시 false.
		estimateAboveSell() {
			if (!this.estimate || !this.estimate.available) return false;
			const est = Number(this.estimate.total) || 0;
			const sell = Number(this.item && this.item.sell_price) || 0;
			return est > 0 && sell > 0 && est > sell;
		},
		// 추정가(AVM) 로드. bid → 백엔드 프록시 → bloc.ai.kr. graceful: 실패 시 available:false 유지.
		getEstimate() {
			return this.$apiGET('/admin/api/detail/item/estimate?bid=' + this.bid).then(data => {
				if (data && data.available) {
					const _t = Math.round((Number(data.totalKrw) || 0) / 10000);
					const _p = Math.round((Number(data.pyUnit) || 0) / 10000);
					this.estimate = { available: true, total: _t, py: _p, areaPy: _p > 0 ? _t / _p : 0 }; // AVM 원→만원; areaPy=평면적(총액/평당) 연동기준
					this.estimateAvm = { total: _t, py: _p };
				} else {
					this.estimate = { available: false, total: 0, py: 0, areaPy: 0 };
					this.estimateAvm = null;
				}
			}).catch(() => {
				this.estimate = { available: false, total: 0, py: 0, areaPy: 0 };
				this.estimateAvm = null;
			}).then(() => this.applyEstimateUrlOverride());
		},
		// 머릿글 strip — 자동 카운터(01/02..)와 중복되지 않도록 한 줄 앞에서
		//   - 기호: ▶ ▷ ► ▸ ➤ → > • · - *
		//   - 대괄호 숫자: [1] [2] [10] ...
		//   - 점/괄호 숫자: 1. 1) 1)
		// 위 패턴이 1개 이상 연속해 있어도 모두 제거.
		getFeatureLines(memo) {
			return (memo || '')
				.split('\n')
				.map(l => l.trim())
				.filter(l => l.length > 0)
				.map(l => l.replace(/^(?:\[\d+\]|\d+[.)]|[▶▷►▸➤→>•·\-*])+\s*/, ''));
		},
		getUser() {
			this.$apiGET('/admin/api/user/info').then(re => {
				this.userInfo = re;
				// if (re) {
				// 	this.$store.dispatch('callSetUserInfo', re);
				// }
			});
		},
		loadMap() {
			// Bug AR (2026-05-11): mapScriptReady.then($nextTick(loadMap)) 이
			// 컴포넌트 unmount 직후 / 또는 v-if="item" 가 아직 false 인 사이의
			// 미세한 race 에서 실행되면 naver.maps.Map 이 "Container map_1 not
			// found" 로 throw → puppeteer pageerror 캡처. this.item 과 컨테이너
			// 존재를 가드해 silent bail. (capture 영역이 DOM 에 없으면 어차피
			// 화면 / PDF 에 노출되지 않으므로 사용자 영향 0.)
			if (!this.item || !this.item.pt) return;
			if (!document.getElementById('map_1') || !document.getElementById('map_2')) return;

			this.map_1 = new window.naver.maps.Map('map_1', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.map_1.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			this.map_1.setSize({ width: '550px', height: '690px' });
			this.marker_1 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map_1,
			});

			this.mapType = new window.naver.maps.CadastralLayer();

			this.map_2 = new window.naver.maps.Map('map_2', {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 18,
			});

			this.mapType.setMap(this.map_2);

			this.map_2.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			this.map_2.setSize({ width: '550px', height: '690px' });
			this.marker_2 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map_2,
			});
		},
		async copyChartImg() {
			this.isPdfLoading = true;
			this.pdfLoadingMsg = '출력 준비 중...';
			this.pdfLoadingCurrent = 0;
			this.pdfLoadingTotal = 0;
			// F-5.1: progress callback passed to $exportPrint
			const onProgress = (current, total) => {
				this.pdfLoadingTotal = total;
				this.pdfLoadingCurrent = current;
				this.pdfLoadingMsg = total > 1
					? `출력 준비 중... (${current}/${total} 페이지)`
					: '출력 준비 중...';
			};
			try {
				this.$apiPOST('/admin/api/detail/item/print', { bidList: [this.bid] }).then(() => {});
				try {
					this.syncEstimateToUrl(); // 편집 추정가를 URL 에 반영(서버 PDF 재로드 대비)
					this.rebuildCapIdList();
					await this.$exportPdf(this.capIdList, this.item.building_name);
				} catch (e) {
					console.warn('Server PDF failed, falling back to client-side:', e);
					await this.$exportPrint(this.capIdList, onProgress, this.item.building_name);
				}
			} finally {
				this.isPdfLoading = false;
				this.pdfLoadingMsg = '';
			}
		},
		// 보이는(offsetParent!==null) + id 있는 capture 섹션만 수집한다.
		// 지도(capture_5)는 v-show 라 체크 해제해도 display:none 으로 DOM 에 잔존하는데,
		// 이를 그대로 capIdList 에 담으면 서버 PDF 가 그 섹션을 빈/거대 페이지로 렌더해
		// 전체 페이지가 축소되고 빈 페이지가 늘어난다. 그래서 보이는 섹션만 골라낸다.
		collectCaptureIds() {
			const ids = [];
			const nodes = document.getElementsByName('capture');
			for (let i = 0; i < nodes.length; i++) {
				const el = nodes[i];
				if (el.id && el.offsetParent !== null) ids.push(el.id);
			}
			return ids;
		},
		rebuildCapIdList() {
			// invShow/devShow 토글로 v-if 페이지가 추가/제거된 뒤 capIdList 가 stale 되어
			// 서버 PDF 가 제거된 셀렉터를 대기(hang)하거나 신규 페이지를 누락하는 문제 방지.
			// 출력은 사용자 클릭(정착된 DOM)에서 트리거되므로 동기 스캔으로 충분.
			markStage('dom-rendered');
			this.capIdList = this.collectCaptureIds();
		},
		getItem() {
			markStage('item-loading');
			this.$apiGET('/admin/api/detail/item?bid=' + this.bid + '&isRent=false').then(async data => {
				// Bug AF: 백엔드가 row 미존재 시 res.send(false) → data === false.
				// Bug Z-2 contract: PDF headless 백엔드는 __VUE_PRINT_STATUS__ 를 polling 하므로
				// terminal 상태 ('ready'/'failed') 미세팅 시 30s 까지 hang 후 timeout 500. fail-fast
				// 위해 reason → status 순서로 세팅 (backend 가 status='failed' 본 직후 reason read).
				if (!data || typeof data !== 'object') {
					markFailed('detail/item returned no row for bid=' + this.bid);
					alert('해당 매물 정보를 찾을 수 없습니다.');
					return;
				}
				markStage('item-loaded');
				if (this.$route.query.st == 'true') {
					data.sell_price = Number(this.$route.query.sell_price);
					data.land_price = Number(this.$route.query.land_price);
					data.land_size_py_price = Number(this.$route.query.land_size_py_price);
					data.building_price = Number(this.$route.query.building_price);
					data.building_price_py_price = Number(this.$route.query.building_price_py_price);
					data.total_size_py_price = Number(this.$route.query.total_size_py_price);
					data.ex_sum_rent_deposit = Number(this.$route.query.ex_sum_rent_deposit);
					data.ex_sum_rent_money = Number(this.$route.query.ex_sum_rent_money);
					data.ex_sum_mgr_fee = Number(this.$route.query.ex_sum_mgr_fee);
					data.ex_sum_mgr_fee_out = Number(this.$route.query.ex_sum_mgr_fee_out);
					data.total_income = Number(this.$route.query.total_income);
					data.total_income_rate = Number(this.$route.query.total_income_rate);
				}

				for (let prop in data) {
					if (data[prop] == null) {
						data[prop] = '';
					}
				}

				data.img = null;

				//썸네일
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						data.img = process.env.VUE_APP_HOST_BACK + '/users/item/image?id=' + data.imgList[i] + '&w=1200&q=82';
						break;
					}
				}

				//이미지 리스트
				let imgObjList = [];
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						imgObjList.push({
							// I1: 사용자가 입력한 라벨이 있으면 그걸, 없으면 IMG_NAME fallback.
							name: (data.imgLabels && data.imgLabels[i] && data.imgLabels[i].length) ? data.imgLabels[i] : this.$IMG_NAME[i],
							img: process.env.VUE_APP_HOST_BACK + '/users/item/image?id=' + data.imgList[i] + '&w=1200&q=82',
							st: true,
						});
					}
				}
				data.imgObjList = imgObjList;

				let imgObj = [];
				for (let i = 0; i < imgObjList.length; i += 2) {
					imgObj.push(imgObjList.slice(i, i + 2));
				}

				data.imgObj = imgObj;

				// F-5.2: set fallback addresses from building data, then fetch land parcels.
				// this.item is assigned only after getLand() resolves so the print UI
				// never renders with stale coverAddr / bodyAddr.
				// F-2.1: legacy row 방어선 — 원시 주소도 정규화 후 세팅.
				const fallbackAddr = normalizeAddr(data.jibun_addr);
				this.coverAddr = fallbackAddr;
				this.bodyAddr = fallbackAddr;
				try { await this.getLand(); } catch(e) { /* fallback already set */ }

				this.item = data;

				this.capIdList = [];

				// 지도는 좌표(item) 확정 즉시 렌더한다 — 느린 추정가(EST_READY_GATE_MS)와 분리.
				// (이전엔 아래 estimate await 뒤에서 loadMap 을 호출해, valuation 이 느려진 PR#78
				//  이후 지도가 최대 15s 늦게 떠 html2canvas 가 빈 지도를 캡처 → 서버 PDF 지도 공백이 났다.)
				this.mapScriptReady
					.then(() => { this.$nextTick(() => { this.loadMap(); }); })
					.catch(e => { console.warn('Naver Maps script failed:', e); });

				// URL/저장 추정가는 즉시 적용 — 서버 PDF 재렌더는 이 값으로 충분(느린 AVM 무관).
				this.applyEstimateUrlOverride();
				// P2(codex): 추정가를 캡처에 포함하되, 느린 valuation 이 ready(서버 캡처 신호)를
				//   막지 않도록 상한(EST_READY_GATE_MS)을 둔다. 늦게 와도 반응성으로 표시 + getEstimate
				//   가 .then 으로 URL override 를 재적용한다.
				try {
					await Promise.race([
						this.estimatePromise,
						new Promise(r => setTimeout(r, EST_READY_GATE_MS)),
					]);
				} catch (e) { /* graceful: 추정가 없이 진행 */ }
				this.applyEstimateUrlOverride();
				this.$nextTick(() => {
					markStage('dom-rendered');
					this.capIdList = this.collectCaptureIds();
					markReady();
				});

				this.indexList = [];
				let idx = 1;
				for (let i = 1; i < this.opList.length; i++) {
					if (this.opList[i]) {
						if (i == 1) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '물건개요',
							});
						} else if (i == 2) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '임대정보',
							});
						} else if (i == 3) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '건축물정보',
							});
						} else if (i == 4) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '건축 내/외부 사진',
							});
						} else if (i == 5) {
							this.indexList.push({
								idx: '0' + idx + '. ',
								name: '지도',
							});
						}
						idx++;
					}
				}

				// (지도 로드는 item 확정 직후로 이동 — getItem 상단 loadMap 호출 참조.)
			});
		},
		updateId() {
			let data = JSON.parse(JSON.stringify(this.item));

			//이미지 리스트
			let imgObjList = [];
			for (let i = 0; i < data.imgObjList.length; i++) {
				if (data.imgObjList[i].st) {
					imgObjList.push(data.imgObjList[i]);
				}
			}

			let imgObj = [];
			for (let i = 0; i < imgObjList.length; i += 2) {
				imgObj.push(imgObjList.slice(i, i + 2));
			}

			this.item.imgObj = imgObj;

			this.$nextTick(() => {
				markStage('dom-rendered');
				this.capIdList = this.collectCaptureIds();
			});

			this.indexList = [];
			let idx = 1;
			for (let i = 1; i < this.opList.length; i++) {
				if (this.opList[i]) {
					if (i == 1) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '물건개요',
						});
					} else if (i == 2) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '임대정보',
						});
					} else if (i == 3) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '건축물정보',
						});
					} else if (i == 4) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '건축 내/외부 사진',
						});
					} else if (i == 5) {
						this.indexList.push({
							idx: '0' + idx + '. ',
							name: '지도',
						});
					}
					idx++;
				}
			}
		},
		getRent() {
			this.$apiGET('/admin/api/detail/item/rent?bid=' + this.bid).then(data => {
				this.rentList = data;
				let m2 = 0;
				let py = 0;
				let deposit = 0;
				let money = 0;
				let mgr = 0;
				// let rent_ni = 0;

				let cnt = data.length;
				let sumCnt = 0;

				for (let i = 0; i < this.rentList.length; i++) {
					if (data[i].rent_money) {
						sumCnt++;
					}

					// 면적은 항상 합산 (F-3.4)
					m2 += Number(this.rentList[i].rent_size_m2);
					py += Number(this.rentList[i].rent_size_p);
					if (this.rentList[i].except_flag != 'Y') {
						deposit += Number(this.rentList[i].rent_deposit);
						money += Number(this.rentList[i].rent_money);
						mgr += Number(this.rentList[i].mgr_fee);
						// rent_ni += Number(this.rentList[i].rent_ni);
					}
				}

				if (cnt) {
					this.rentRate.datasets[0].data[0] = Number(((sumCnt / cnt) * 10 * 10).toFixed(2));
				} else {
					this.rentRate.datasets[0].data[0] = 0;
				}

				const rentGroup = this.$groupBy(data, 'rent_usage');
				for (let prop in rentGroup) {
					const curCnt = rentGroup[prop].length;
					this.rentRateList.datasets.push({
						label: prop,
						data: [Number(((curCnt / cnt) * 100).toFixed(2))],
					});
				}

				this.rentRateSt = true;
				this.rentRateListSt = true;

				this.totalData.m2 = m2.toFixed(2);
				this.totalData.py = py.toFixed(2);
				this.totalData.deposit = deposit;
				this.totalData.money = money;
				this.totalData.mgr = mgr;

				this.totalData.rent_ni = (Number(this.totalData.money) / Number(this.totalData.py)).toFixed(2);
			});
		},
		getFloor() {
			this.$apiGET('/admin/api/detail/item/floor?bid=' + this.bid).then(data => {
				this.floorList = data;
				let m2 = 0;
				let py = 0;

				for (let i = 0; i < this.floorList.length; i++) {
					// 건축물대장이 면적 제외로 표시한 행(옥탑 계단실 등)은 연면적에 들지 않는다(DD). 담당자 제외 체크와는 별개다.
					if (String(this.floorList[i].areaExctYn) === '1') continue;
					m2 += Number(this.floorList[i].area_m2);
					py += Number(this.floorList[i].area_py);
				}

				this.totalFloorData.m2 = m2.toFixed(2);
				this.totalFloorData.py = py.toFixed(2);
			});
		},
		getLand() {
			return this.$apiGET('/admin/api/detail/item/edit/land?bid=' + this.bid).then(data => {
				// F-2.1: legacy row 방어선 — 렌더 직전에 "서울특별시 … 번지" 정규화.
				// F-2.3: dedup (동일 주소 반복 방지).
				const uniqueAddrs = [...new Set(
					data.map(d => normalizeAddr(d.jibun_addr)).filter(Boolean)
				)];
				if (uniqueAddrs.length > 1) {
					this.coverAddr = uniqueAddrs[0] + ' 외 ' + (uniqueAddrs.length - 1) + '필지';
				} else if (uniqueAddrs.length === 1) {
					this.coverAddr = uniqueAddrs[0];
				}
				// F-5.2: 본문은 시/구 제거 + 동일 동 반복 생략 포맷.
				this.bodyAddr = formatBodyAddr(uniqueAddrs) || this.coverAddr;
			});
		},
		setAllCheck() {
			for (let i = 0; i < this.opList.length; i++) {
				this.opList[i] = this.opAll;
			}
			this.updateId();
		},
	},
};
</script>

<style lang="scss" scoped>
// 물건개요(2페이지) — V07 Summary (header + title band + metric bar) 위에
// 구버전 OLD 단순 테이블 레이아웃 + 사진 560×500 fixed 결합.
.print-section.property-overview {
	display: flex !important;
	flex-direction: column;
	position: relative;
	padding: 56px 40px 36px !important;
	box-sizing: border-box;
	background: #fbf9f3;
	height: 820px;
	overflow: hidden;

	// ===== V07 Summary =====
	.overview-header {
		position: absolute;
		top: 22px;
		left: 40px;
		right: 40px;
		display: flex;
		align-items: center;
		gap: 24px;
		padding-bottom: 10px;
		color: #8a8680;
		border-bottom: 1px solid rgba(138, 134, 128, 0.36);

		.overview-caption {
			font-size: 13px;
			letter-spacing: 0.42em;
			text-transform: uppercase;
			font-weight: 500;
			white-space: nowrap;
		}
		.overview-line { flex: 1 1 auto; height: 0; }
		.overview-brand {
			flex: 0 0 auto;
			width: 108px;
			height: 24px;
			background: url(../assets/images/weonus_wordmark_bk.png) no-repeat right center / contain;
		}
	}
	// Summary: 좌측 절반 너비 (.left 안에 위치) — 폰트 축소로 height 감소
	.overview-title-band {
		display: flex;
		align-items: baseline;
		flex-wrap: nowrap;
		gap: 8px;
		margin: 0 0 6px;
		overflow: hidden;

		.title-main {
			font-size: 18px;
			font-weight: 800;
			color: #1a1714;
			letter-spacing: -0.025em;
			line-height: 1.1;
			white-space: nowrap;
		}
		.title-slash {
			font-size: 15px;
			font-weight: 200;
			color: #cfc7b9;
			line-height: 1;
			padding: 0 1px;
		}
		.title-addr {
			font-size: 11px;
			font-weight: 400;
			color: #8a8680;
			letter-spacing: 0.005em;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			flex: 0 1 auto;
			min-width: 0;
		}
	}
	.metric-bar {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		background: #7a1c1c;
		color: #fbf9f3;
		padding: 6px 0;
		margin: 0 0 10px;
		border-radius: 0;
		flex: 0 0 auto;
		// 4셀 모두 동일 14px value + label/value/sub 가 같은 y position 에서 시작.
		// 길이가 셀 폭을 넘으면 wrap 으로 풀어 '...' truncation 을 방지하기 위해
		// 2줄 worst case (주변역 '수원시청역(수인분당선)') 까지 수용하도록 76px.
		height: 76px;
		box-sizing: border-box;

		.metric {
			padding: 8px 6px 0;
			box-sizing: border-box;
			border-right: 1px solid rgba(251, 249, 243, 0.2);
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 1px;
			height: 100%;
			min-width: 0;
			// 첫 셀(매매금액) 은 burgundy bar 좌단과 너무 붙지 않도록 살짝 더 띄움.
			&:first-child { padding-left: 14px; }
			&:last-child { border-right: none; }

			.metric-label {
				font-size: 9px;
				letter-spacing: 0.18em;
				color: rgba(251, 249, 243, 0.72);
				font-weight: 500;
				text-transform: uppercase;
				white-space: nowrap;
				line-height: 1.2;
			}
			.metric-value {
				font-size: 14px;
				font-weight: 800;
				color: #fbf9f3;
				line-height: 1.15;
				letter-spacing: -0.02em;
				// '...' truncation 금지 — 셀 폭 안에서 wrap 으로 풀어 2줄까지 허용.
				white-space: normal;
				word-break: keep-all;
				overflow-wrap: anywhere;
				max-width: 100%;
			}
			.metric-sub {
				display: block;
				font-size: 8.5px;
				color: rgba(251, 249, 243, 0.62);
				letter-spacing: 0.03em;
				font-weight: 400;
				line-height: 1.2;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 100%;
			}
		}
	}

	// ===== Body row: 좌(Summary + tables) | 우(사진 + 특징) — 50:50 분할 =====
	.body-row {
		display: flex;
		flex-direction: row;
		flex: 1 1 auto;
		min-height: 0;
		gap: 16px;
		margin-top: 6px; // overview-header(absolute) 와의 안전 마진
	}
	.left {
		flex: 1 1 50%;
		min-width: 0;
		display: flex;
		flex-direction: column;
	}
	.section-tit--print-header {
		background-color: #a23334;
		color: #fff !important;
		border-color: #a23334 !important;
		padding: 4px 10px;
		border-radius: 2px;
	}
	.left .bottom {
		.section-tit--print-header {
			margin-top: 6px;
			margin-bottom: 4px;
			font-size: 13px;
			&:first-child { margin-top: 0; }
		}
		.table.compact {
			margin-bottom: 0;
			th, td {
				padding: 2px 8px;
				font-size: 11.5px;
				line-height: 1.25;
			}
			th { font-weight: 500; }
			th.txt-c--red, td.txt-c--red { font-weight: 700; }
		}
	}
	.right {
		flex: 1 1 50%;
		min-width: 0;
		display: flex;
		flex-direction: column;
		align-self: stretch;
		.img-wrap {
			// 사진 영역 — width 100% + 7:8 (width:height) 세로형 비율로 원본(flex:1 1 auto
			// 잔여 흡수 시 ~552px) 과 유사한 시각 크기 유지. flex:0 1 auto + min-height:0 으로
			// 특징이 길어 column 을 넘기는 경우엔 사진이 자연스럽게 살짝 줄어들 수 있도록 함.
			// (4:3 으로 했더니 사진이 너무 작아 보였다는 피드백 반영)
			flex: 0 1 auto;
			width: 100%;
			aspect-ratio: 7 / 8;
			min-height: 0;
			overflow: hidden;
			background: #f2eeea;
			.property-photo-fixed {
				width: 100%;
				height: 100%;
				// "안잘리게" — 어떤 비율의 건물 사진이라도 크롭 없이 전체가 보이도록 contain.
				object-fit: contain;
				display: block;
			}
		}
		.section-tit--print-header.features-header {
			flex: 0 0 auto;
			margin-top: 4px;
			margin-bottom: 2px;
		}
		// 특징 — 01/02/03 빨간색 자동 카운터 (PrintPage2 와 동일 스타일).
		// max-height/overflow 제한 없음 — 사진 아래 딱 붙어 콘텐츠 분량 만큼 자연스럽게
		// 아래로 확장. 우측 column 잔여 공간(약 450px) 안에서 자유롭게 늘어남.
		.features-list.box-line.features-body {
			flex: 0 0 auto;
			box-sizing: border-box;
			background: #fbf9f3;
			border: 1px solid #ede3d1;
			border-top: none;
			border-radius: 0;
			padding: 12px 16px;
			margin: 0;
			list-style: none;
			font-size: 11.5px;
			line-height: 1.5;
			color: #2c2a27;
			counter-reset: feat;

			li {
				position: relative;
				padding: 0 0 6px 26px;
				margin: 0;
				counter-increment: feat;
				white-space: normal;
				word-break: keep-all;
				&:last-child { padding-bottom: 0; }

				&::before {
					content: counter(feat, decimal-leading-zero);
					position: absolute;
					left: 0;
					top: 1px;
					color: #dc3545;
					font-weight: 700;
					font-size: 10px;
					letter-spacing: 0.08em;
					font-variant-numeric: tabular-nums;
					line-height: 1.7;
				}
			}
		}
	}
}

// 2페이지 이후 모든 페이지 하단의 법적 고지 (회색·9px·2줄). `.print-section`(전역 position:relative)
// 내부에 absolute 배치 — watermark(::after, z-index:5) 위로 올라오도록 z-index:6.
.page-footer-disclaimer {
	position: absolute;
	left: 24px;
	right: 24px;
	bottom: 6px;
	z-index: 6;
	padding: 3px 6px 2px;
	background: rgba(255, 255, 255, 0.92);
	border-top: 1px solid rgba(0, 0, 0, 0.05);
	font-size: 7.5px;
	line-height: 1.45;
	color: #6b6b6b;
	letter-spacing: -0.01em;
	pointer-events: none;
	p {
		margin: 0;
		text-indent: -6px;
		padding-left: 6px;
		word-break: keep-all;
	}
	p + p { margin-top: 1px; }
}
// 표지 직후 첫 본문(property-overview)은 배경이 #fbf9f3 — footer 배경을 같은 톤으로.
.print-section.property-overview .page-footer-disclaimer {
	background: rgba(251, 249, 243, 0.95);
	border-top-color: rgba(122, 28, 28, 0.08);
}

// F-3.5 제외 row 연회색 처리 스타일은 assets/css/common.scss 로 이동 (전역 단일 정의).
.pdf-loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}
.pdf-loading-spinner {
	background: white;
	padding: 30px 50px;
	border-radius: 8px;
	font-size: 18px;
	font-weight: bold;
	min-width: 260px;
	text-align: center;
}
.pdf-loading-text {
	margin-bottom: 14px;
}
.pdf-loading-bar-wrap {
	width: 100%;
	height: 8px;
	background: #e0e0e0;
	border-radius: 4px;
	overflow: hidden;
}
.pdf-loading-bar {
	height: 100%;
	background: #1976d2;
	border-radius: 4px;
	transition: width 0.25s ease;
}

/* =========================================================
 * 표지(cover) 3 variant — 레퍼런스 정밀 재현
 *   - 페이퍼 텍스처, 2-tone 레드, 3-band 레이아웃, 가는 라인 모티브
 * ========================================================= */

// 제휴 게스트(신한/대신) 표지: 위온어스 단독 워드마크 → 위온어스×기관 공동로고 흰 카드.
// 공동로고는 배경색에 맞춘 투명배경 png 사용(받침 없음):
//   밝은 배경(V01 near-white / V05 흰카드) → -color (we'onus 검정 + 은행 컬러)
//   어두운 배경(V02 버건디) → -white (we'onus 흰색 + 은행 흰색 역상)
// 영역에 background-size:contain 으로 맞추고 position 은 variant 별 지정.
@mixin cover-cobrand-logo {
	background-repeat: no-repeat;
	background-size: contain;
}

// 페이퍼 그레인 텍스처 (레퍼런스 배경 노이즈 재현)
// V01/V02/V05 한정. V00 (Classic, cover-00)은 common.scss 의 글로벌 `.print-section.cover` 스타일을
// 그대로 사용해야 하므로 :not(.cover-00) 으로 제외 — 이 블록의 align/.tit/.logo 강제 숨김이 V00 에 적용되면 안 됨.
.print-section.cover[class*='cover-0']:not(.cover-00) {
	position: relative;
	padding: 0;
	overflow: hidden;
	// common.scss 의 `.print-section.cover { align-items:center; justify-content:center; }` 오버라이드.
	// 3 variant 는 모두 풀폭 자식을 사용하므로 stretch + flex-start 로 레이아웃.
	align-items: stretch !important;
	justify-content: flex-start !important;

	:deep(.logo),
	.logo { display: none !important; }
	:deep(.tit),
	.tit { display: none !important; }

	// ===== 공통 컴포넌트 =====
	.cover-caption {
		font-size: 13px;
		letter-spacing: 0.34em;
		text-transform: uppercase;
		font-weight: 500;
		white-space: nowrap;
	}
	.cover-title {
		line-height: 1.06;
		font-weight: 800;
		margin: 0;
		word-break: keep-all;
		letter-spacing: -0.01em;
		white-space: pre-line;
	}
	.cover-addr {
		font-size: 14px;
		letter-spacing: 0.04em;
	}
	.cover-wordmark {
		width: 130px;
		height: 26px;
		background: url(../assets/images/weonus_wordmark_bk.png) no-repeat center / contain;
		flex: 0 0 auto;
	}
	.cover-paper {
		position: absolute;
		inset: 0;
		background: url(../assets/images/paper_texture.png);
		background-repeat: repeat;
		mix-blend-mode: multiply;
		opacity: 0.6;
		pointer-events: none;
		z-index: 1;
	}
	.cover-split {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: stretch;
		z-index: 2;
	}

	// ===== Variant 01: Editorial (near-white 캔버스 + 우측 full-height 사진) =====
	// PIL 픽셀 측정(ref 1536×1024), x scale=0.7617, y scale=0.8008:
	//   캡션:       ref y=107~124 x=170~398  → y=85 x=129 w=235 (neutral gray)
	//   상단 라인:  ref y=154 x=70~1463      → y=123 x=53 → x=1115
	//   타이틀 L1:  ref y=229~314            → y=183~251  (line-height 68)
	//   타이틀 L2:  ref y=350~436            → y=280~349  font ~60
	//   주소 pill:  ref y=480~530 x=168~483  → y=384~424 x=128 w=240 h=40
	//   사진 박스:  ref y=154~1024 x=936~1536 → y=123~820 x=713 w=457 (full-height)
	//   wordmark:   ref y=802~822 x=166~324  → y=642 x=126 w=118
	//   하단 라인:  ref y=811 L:x=39~132 R:x=353~912 → y=650 L:x=30 w=71 / R:x=269 w=426
	&.cover-01 {
		background: #fbfaf5;
		color: #3c3a36;
		.cover-paper { opacity: 0.18; }

		.cover-caption {
			position: absolute;
			top: 75px;
			left: 129px;
			color: #86867f;
			font-weight: 400;
			font-size: 16px;
			letter-spacing: 0.42em;
			z-index: 3;
		}
		.cover-top-line {
			position: absolute;
			top: 123px;
			left: 53px;
			right: 55px;
			height: 1px;
			background: #cac4b4;
			z-index: 3;
		}
		.cover-vstripe {
			position: absolute;
			top: 123px;
			bottom: 0;
			left: 713px;
			width: 13px;
			background: #8d271f;
			z-index: 4;
		}
		.cover-photo-box {
			position: absolute;
			top: 123px;
			left: 726px;
			right: 0;
			bottom: 0;
			overflow: hidden;
			background: #e0dbce;
			z-index: 2;

			.cover-photo {
				width: 100%;
				height: 100%;
				object-fit: cover;
				display: block;
			}
		}
		.cover-title {
			position: absolute;
			top: 183px;
			left: 129px;
			max-width: 420px;
			font-size: 60px;
			color: #8d271f;
			letter-spacing: -0.012em;
			line-height: 1.15;
			z-index: 3;
			margin: 0;
			// 공백 기준 자동 줄바꿈 (Korean keep-all)
			word-break: keep-all;
			word-spacing: 9999px;
		}
		.cover-addr-pill {
			position: absolute;
			top: 384px;
			left: 128px;
			height: 40px;
			padding: 0 20px;
			display: inline-flex;
			align-items: center;
			background: transparent;
			color: #6b6761;
			font-size: 13px;
			letter-spacing: 0.04em;
			border: 1px solid #d2ccbd;
			border-radius: 20px;
			z-index: 3;
			white-space: nowrap;
		}
		.cover-wordmark {
			position: absolute;
			top: 636px;
			left: 126px;
			width: 118px;
			height: 26px;
			z-index: 3;
		}
		.cover-bottom-line-l {
			position: absolute;
			top: 650px;
			left: 30px;
			width: 71px;
			height: 1px;
			background: #cac4b4;
			z-index: 2;
		}
		.cover-bottom-line-r {
			position: absolute;
			top: 650px;
			left: 269px;
			width: 426px;
			height: 1px;
			background: #cac4b4;
			z-index: 2;
		}
		// disclaimer — 빨간 글자 (테두리 없이, 사용자 요청으로 크게)
		.cover-disclaimer {
			position: absolute;
			top: 690px;
			left: 53px;
			width: 640px;
			padding: 0;
			border: none;
			color: #9c252f;
			font-size: 13px;
			line-height: 1.5;
			letter-spacing: 0.005em;
			word-break: keep-all;
			word-spacing: 0.06em;
			z-index: 4;
		}
		// 제휴 게스트 공동로고 — near-white 배경 → 컬러(투명배경) 로고, 받침 없음. flanking line 숨김.
		&.shinhan,
		&.daishin {
			.cover-bottom-line-l,
			.cover-bottom-line-r { display: none; }
			.cover-wordmark {
				@include cover-cobrand-logo;
				background-position: left center;
				top: 632px;
				left: 129px;
				right: 457px;
				width: auto;
				height: 34px;
			}
		}
		&.shinhan .cover-wordmark { background-image: url(../assets/partner/cobrand-shinhan-color.png); }
		&.daishin .cover-wordmark { background-image: url(../assets/partner/cobrand-daishin-color.png); }
	}

	// ===== Variant 02: Bold Burgundy — 3-band 절대 좌표 배치 =====
	// PIL 픽셀 측정(ref 1536×1024), scale x=0.7617 y=0.8008:
	//   상단 cream strip:    ref y=0~140 → y=0~112 (h=112)
	//   PROPERTY OVERVIEW:   ref y=72~88 x=114~452 → y=58 x=87 w=258 (burgundy 텍스트만, 좌우 라인 없음)
	//   본문 burgundy:       ref y=140~856 → y=112~686 (h=574)
	//   photo:               ref x=848~1536 → x=646~1170 (full height of main)
	//   title L1:            ref y=254~344 → y=203~275 (main-rel 91~163)
	//   title L2:            ref y=375~467 → y=300~374 (main-rel 188~262)
	//   addr (plain):        ref y=513~537 x=129~340 → y=411 x=98 (main-rel 299)
	//   wordmark:            ref y=802~820 x=117~250 → y=642 x=89 w=101 h=14 (main-rel 530)
	//   line-l:              ref y=809 x=54~91      → y=648 x=41 w=28 (main-rel 536)
	//   line-r:              ref y=808 x=280~844    → y=648 x=213 w=430 (main-rel 536)
	//   하단 cream strip:    ref y=856~1024 → y=686~820 (h=134)
	//   footer-addr:         ref y=944~961 x=116~340 → y=756 x=88 (strip-rel 70)
	&.cover-02 {
		background: #9c252f;

		.cover-top-strip {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 112px;
			background: #fbfaf5;
			z-index: 5;

			.cover-caption {
				position: absolute;
				top: 54px;
				left: 87px;
				color: #8a2128;
				font-weight: 500;
				font-size: 18px;
				letter-spacing: 0.44em;
			}
		}

		.cover-main {
			position: absolute;
			top: 112px;
			left: 0;
			right: 0;
			bottom: 134px; // 하단 cream strip 자리 남김 (ref y=856~1024 → h=134)
			color: #f4e6d4;
			background: #9c252f;
			box-shadow:
				inset 120px 0 160px -100px rgba(40, 8, 10, 0.45),
				inset 0 40px 80px -50px rgba(40, 8, 10, 0.30);

			.cover-paper { opacity: 0.25; }

			.cover-vdecor-w1 {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 646px;
				width: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
			.cover-vdecor-dark {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 648px;
				width: 66px;
				background: #6b151b;
				z-index: 3;
			}
			.cover-vdecor-w2 {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 714px;
				width: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
			.cover-photo-box {
				position: absolute;
				top: 0;
				left: 716px;
				right: 0;
				bottom: 0;
				overflow: hidden;
				background: #7d2627;

				.cover-photo {
					width: 100%;
					height: 100%;
					object-fit: cover;
					display: block;
				}
			}
			.cover-title {
				position: absolute;
				top: 110px;
				left: 88px;
				right: 546px;
				font-size: 64px;
				color: #fff;
				letter-spacing: -0.005em;
				line-height: 1.12;
				margin: 0;
				z-index: 2;
				font-weight: 800;
			}
			.cover-addr {
				position: absolute;
				top: 340px;
				left: 98px;
				color: rgba(244, 230, 212, 0.92);
				font-size: 14px;
				letter-spacing: 0.05em;
				z-index: 2;
			}
			// wordmark — ref y=802~820 → main-rel 530 (main top 112 기준)
			.cover-wordmark {
				position: absolute;
				top: 530px;
				left: 89px;
				width: 115px;
				height: 26px;
				background-image: url(../assets/images/weonus_wordmark_wh.png);
				background-size: contain;
				background-repeat: no-repeat;
				z-index: 2;
			}
			// wordmark 양옆 flanking 하얀 가로줄 — ref y=809 → main-rel 536
			.cover-bottom-line-l {
				position: absolute;
				top: 542px;
				left: 42px;
				width: 27px;
				height: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
			.cover-bottom-line-r {
				position: absolute;
				top: 542px;
				left: 214px;
				width: 501px;
				height: 2px;
				background: #fbfaf5;
				z-index: 3;
			}
		}

		// 하단 cream strip — 본문 burgundy 아래, 본문과 경계 자연스러운 hard edge
		// ref y=856~1024 → y=686~820 (h=134). footer-addr ref y=944 → y=756 (strip-rel 70)
		.cover-bottom-strip {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 134px;
			background: #fbfaf5;
			z-index: 5;

			// disclaimer — 크림 strip 내부 빨간 글자 (테두리 제거 + 크기 확대)
			.cover-disclaimer {
				position: absolute;
				top: 14px;
				left: 88px;
				right: 88px;
				bottom: 14px;
				padding: 0;
				border: none;
				color: #9c252f;
				font-size: 13px;
				line-height: 1.5;
				letter-spacing: 0.005em;
				word-break: keep-all;
				word-spacing: 0.08em;
				display: flex;
				align-items: center;
			}
		}
		// 제휴 게스트 공동로고 — 버건디 배경 → 흰색 역상(투명배경) 로고, 받침 없음. flanking line 숨김.
		&.shinhan,
		&.daishin {
			.cover-main {
				.cover-bottom-line-l,
				.cover-bottom-line-r { display: none; }
				.cover-wordmark {
					@include cover-cobrand-logo;
					background-position: left center;
					top: 524px;
					left: 88px;
					right: 524px;
					width: auto;
					height: 36px;
				}
			}
		}
		&.shinhan .cover-main .cover-wordmark { background-image: url(../assets/partner/cobrand-shinhan-white.png); }
		&.daishin .cover-main .cover-wordmark { background-image: url(../assets/partner/cobrand-daishin-white.png); }
	}

	// ===== Variant 05: Boutique Advisory (플랫 burgundy + floating 카드 + 하단 cream 스트립) =====
	// PIL 픽셀 측정(ref 1536×1024), scale x=0.7617 y=0.8008:
	//   bg burgundy:         RGB(143,43,50) ≈ #8f2b32 (uniform, 외곽 darker frame 없음)
	//   top band 영역:       ref y=100~175 (시각적 darker band — PIL 측정상 균일, shadow overlay 로 재현)
	//   PROPERTY OVERVIEW:   ref y=137 중심 x=170~439 → y=110 x=130 (caption)
	//   we'onus top-right:   ref y=135 중심 x=1242~1391 → y=108 x=946 w=96
	//   thin divider line:   ref y=177 → y=142 (across most of width)
	//   card (left):         ref x=170~770 y=308~830 → x=130 y=247 w=457 h=418
	//   photo:               ref x~770~1440 y=180~830 → x=586 y=144 w=524 h=520
	//   bottom cream strip:  ref x=93~1439 y=836~925 → x=71 y=670 w=1027 h=71
	&.cover-05 {
		background: #8f2b32;
		color: #f4e6d4;

		// 상단 darker band — frame 내부에 위치, PROPERTY OVERVIEW + we'onus 영역
		.cover-top-band {
			position: absolute;
			top: 82px;
			left: 75px;
			right: 75px;
			height: 60px;
			background: #a63a40;
			z-index: 2;
		}

		.cover-top-outer {
			position: absolute;
			top: 82px;
			left: 99px;
			right: 99px;
			height: 60px;
			z-index: 6;

			.cover-top-row {
				position: absolute;
				top: 22px;
				left: 0;
				right: 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 24px;

				.cover-caption {
					color: #fbfaf5;
					font-size: 12px;
					letter-spacing: 0.38em;
					line-height: 1;
					font-weight: 500;
				}
				.cover-wordmark--top {
					width: 96px;
					height: 22px;
					background-image: url(../assets/images/weonus_wordmark_wh.png);
					background-repeat: no-repeat;
					background-position: center;
					background-size: contain;
				}
			}

			.cover-top-line {
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				height: 1px;
				background: rgba(250, 244, 235, 0.5);
			}
		}

		// 사진 영역 — bg 와 분리된 별도 영역 (카드 오른쪽)
		.cover-bg {
			position: absolute;
			top: 78px;
			left: 71px;
			right: 71px;
			bottom: 150px;
			overflow: hidden;
			background: #8f2b32;
			// 액자 — 상/좌/우만 shadow (bottom shadow 제거 — cream strip 오염 방지)
			box-shadow:
				0 -24px 48px rgba(0, 0, 0, 0.32),
				-24px 0 48px rgba(0, 0, 0, 0.28),
				24px 0 48px rgba(0, 0, 0, 0.28);
			z-index: 1;

			.cover-photo {
				position: absolute;
				top: 64px;
				left: 0;
				right: 0;
				bottom: 0;
				width: 100%;
				height: calc(100% - 64px);
				object-fit: cover;
				display: block;
				filter: grayscale(100%) contrast(1.08) brightness(1.02) sepia(0.15);
			}
			.cover-bg-tint {
				position: absolute;
				inset: 0;
				background: linear-gradient(
					180deg,
					rgba(110, 26, 32, 0.12) 0%,
					rgba(110, 26, 32, 0.15) 40%,
					rgba(110, 26, 32, 0.6) 70%,
					rgba(90, 18, 24, 0.92) 100%
				);
				mix-blend-mode: multiply;
				pointer-events: none;
			}
			.cover-bg-scrim {
				position: absolute;
				inset: 0;
				background: linear-gradient(180deg, rgba(52, 12, 18, 0.0) 70%, rgba(52, 12, 18, 0.38) 100%);
				pointer-events: none;
			}
		}

		// 하단 cream band — ref x=93~1439 y=836~925 → x=71 y=670 w=1027 h=71
		.cover-cream-band {
			position: absolute;
			top: 670px;
			left: 71px;
			right: 71px;
			height: 95px;
			background: #fbfaf5;
			z-index: 3;

			// disclaimer — cream band 내부 빨간 글자 (테두리 제거 + 크기 확대)
			.cover-disclaimer {
				position: absolute;
				top: 8px;
				left: 24px;
				right: 24px;
				bottom: 8px;
				padding: 0;
				border: none;
				color: #9c252f;
				font-size: 13px;
				line-height: 1.5;
				letter-spacing: 0.005em;
				word-break: keep-all;
				word-spacing: 0.08em;
				display: flex;
				align-items: center;
			}
		}

		// 좌측 카드 — card bottom = cream-band top (touching, 같은 색 #fbfaf5 로 seamless 연결)
		// card 는 strip 위에 "딱 붙어" 앉음 (overlap 없음), bottom shadow 없음 (strip 오염 방지)
		.cover-card {
			position: absolute;
			left: 130px;
			top: 247px;
			width: 457px;
			// bottom exactly at strip top (670) — top 247 + height 423 = 670
			height: 423px;
			box-sizing: border-box;
			padding: 48px 40px 28px;
			background: #fbfaf5;
			box-shadow:
				-5px 0 20px rgba(0, 0, 0, 0.22),
				0 -4px 20px rgba(0, 0, 0, 0.18),
				5px 0 20px rgba(0, 0, 0, 0.18);
			// bottom shadow + right/left shadow 아래쪽 leak 방지 → strip 영역까지 clip
			clip-path: inset(-30px -30px 0 -30px);
			display: flex;
			flex-direction: column;
			z-index: 7;

			// 내부 matte 외곽선 — 레퍼런스 기준 4면 1px hairline
			// top/left/right: #9e9e9e (ref ~#a0a0a0)
			// bottom: #cdcbc9 — ref 에서 카드-strip 경계 은은한 lighter gray
			// 14px inset on all sides — ref 에서 카드 가장자리로부터 안쪽
			&::before {
				content: '';
				position: absolute;
				top: 14px;
				left: 14px;
				right: 14px;
				bottom: 0;
				border-top: 1px solid #9e9e9e;
				border-left: 1px solid #9e9e9e;
				border-right: 1px solid #9e9e9e;
				border-bottom: 1px solid #cdcbc9;
				pointer-events: none;
				z-index: 2;
			}

			// 카드 중간 가로 divider — 레퍼런스 y=661(=285 CSS from card top)
			// title/addr 구역과 wordmark 구역을 나누는 hairline
			&::after {
				content: '';
				position: absolute;
				top: 285px;
				left: 14px;
				right: 14px;
				height: 1px;
				background: #9e9e9e;
				pointer-events: none;
				z-index: 2;
			}

			.cover-title {
				font-size: 46px;
				color: #9c252f;
				margin: 0 0 22px;
				line-height: 1.12;
				letter-spacing: -0.005em;
				font-weight: 800;
			}
			.cover-addr {
				display: flex;
				align-items: center;
				gap: 7px;
				color: #6b6761;
				font-size: 12px;
				letter-spacing: 0.03em;

				.pin-icon {
					flex: 0 0 auto;
					color: #9c252f;
					margin-top: -2px;
				}
			}
			// wordmark + 우측 수평선을 한 줄에 (레퍼런스: 로고 옆으로 가는 선)
			// cream-band 영역(y=670~765)과 겹치는 하단에 배치해야 visual 로 로고가 크림밴드 위에 앉은 것처럼 보임
			.cover-card-footer {
				margin-top: auto;
				// card top=247, cream-band top=670 → 로고 수직 중심을 카드 하단부 cream-band 구간에 배치
				// footer 를 cream-band 의 세로 중심(y=717)에 맞추기: card 안에서 y=717-247=470
				// footer 높이 ~24px 이면 top=458
				margin-bottom: 16px;
				display: flex;
				align-items: center;
				gap: 14px;
				min-height: 24px;

				.cover-wordmark {
					flex: 0 0 auto;
					width: 118px;
					height: 24px;
				}
				.cover-card-divider {
					flex: 1 1 auto;
					height: 1px;
					background: rgba(156, 37, 47, 0.32);
				}
			}
		}
		// 제휴 게스트 공동로고 — 흰 카드 위 footer → 컬러(투명배경) 로고, 받침 없음. divider 숨김.
		&.shinhan,
		&.daishin {
			.cover-card-footer {
				justify-content: center;
				.cover-card-divider { display: none; }
				.cover-wordmark {
					@include cover-cobrand-logo;
					background-position: center;
					width: 300px;
					height: 32px;
					margin: 0 auto;
				}
			}
		}
		&.shinhan .cover-card-footer .cover-wordmark { background-image: url(../assets/partner/cobrand-shinhan-color.png); }
		&.daishin .cover-card-footer .cover-wordmark { background-image: url(../assets/partner/cobrand-daishin-color.png); }
	}
}

/* =========================================================
 * cover-variant-picker (좌측 툴바 내부, 출력 버튼 위)
 * ========================================================= */
.cover-variant-picker {
	display: flex;
	flex-wrap: wrap;
	gap: 10px 16px;
	align-items: center;
	padding: 10px 12px;
	margin-top: 12px;
	background: #f8f8f8;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 13px;

	.label {
		font-weight: 600;
		color: #333;
	}
	label {
		display: inline-flex;
		gap: 4px;
		align-items: center;
		cursor: pointer;
		margin: 0;
	}
	input[type='radio'] {
		margin: 0;
	}
}

.estimate-control { padding: 0 4px; }
.estimate-control .estimate-edit { display: flex; flex-direction: column; gap: 6px; margin-top: 8px; }
.estimate-control .estimate-edit label { display: flex; flex-direction: column; font-size: 12px; gap: 2px; }
.estimate-control .estimate-avm { display: flex; align-items: center; justify-content: space-between; gap: 6px; font-size: 12px; color: #555; }
.estimate-note-row td { background: transparent; }
.estimate-badge { display: inline-block; padding: 2px 9px; border-radius: 12px; font-size: 12px; font-weight: 700; margin-left: 8px; vertical-align: middle; }
.estimate-badge--under { background: #1f8a4c; color: #fff; }
.estimate-badge--premium { background: #1f8a4c; color: #fff; }
.estimate-badge--equal { background: #888; color: #fff; }
.estimate-note-text { display: inline; font-size: 9px; color: #555; line-height: 1.3; white-space: nowrap; padding: 0; background: transparent; vertical-align: middle; }
.note-badge { display: inline-block; background: #6b7280; color: #fff; font-size: 8px; font-weight: 700; padding: 1px 5px; border-radius: 10px; margin-right: 4px; vertical-align: middle; }
.sell-compare { font-size: 12px; color: #1f8a4c; font-weight: 600; }

@media print {
	.no-print,
	.cover-variant-picker {
		display: none !important;
	}
}
</style>
